import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UFS } from '../../shared/localizacao/municipios';
import { S3SrpPublicService } from '../../services/s3-srp-public.service';

@Component({
  selector: 'app-srp-municipio',
  templateUrl: './srp-municipio.component.html',
  styleUrls: ['../srm-municipio/srm-municipio.component.css']
})
export class SrpMunicipioComponent implements OnInit, OnDestroy {
  ufSelecionada = 'BR';
  dataSelecionada: string | null = null;
  datas: string[] = [];
  ufs = UFS;
  paises = [{ nome: 'Brasil', sigla: 'BR', alias: 'brasil' }];
  loading = false;
  erroCarregamento = false;
  private subscriptions = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private s3SrpPublicService: S3SrpPublicService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(this.route.paramMap.subscribe(params => {
      const uf = (params.get('uf') || 'BR').toUpperCase();
      this.ufSelecionada = uf === 'BR' || this.ufs.some(item => item.sigla === uf) ? uf : 'BR';
    }));
    this.subscriptions.add(this.route.queryParamMap.subscribe(params => {
      this.applySelectedData(params.get('data'));
    }));
    this.carregarDatas();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async carregarDatas(): Promise<void> {
    this.loading = true;
    this.erroCarregamento = false;
    try {
      const months = await this.s3SrpPublicService.listAvailableMonths();
      this.datas = months.filter(month => /^\d{4}(0[1-9]|1[0-2])$/.test(month))
        .sort().reverse().map(month => `${month.slice(4)}/${month.slice(0, 4)}`);
      this.applySelectedData(this.route.snapshot.queryParamMap.get('data'));
    } catch {
      this.datas = [];
      this.dataSelecionada = null;
      this.erroCarregamento = true;
    } finally {
      this.loading = false;
    }
  }

  private applySelectedData(data: string | null): void {
    this.dataSelecionada = data && this.datas.includes(data) ? data : (this.datas[0] || null);
  }

  get currentQueryParams(): { data?: string } {
    return this.dataSelecionada ? { data: this.dataSelecionada } : {};
  }

  navegarParaUf(uf: string): void {
    this.router.navigate(['/srp/municipio', uf], { queryParams: this.currentQueryParams });
  }

  onDataChange(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: this.currentQueryParams,
      queryParamsHandling: 'merge'
    });
  }

  get imagemSrpUrl(): string | null {
    const local = this.ufs.find(uf => uf.sigla === this.ufSelecionada)
      || this.paises.find(pais => pais.sigla === this.ufSelecionada);
    if (!local || !this.dataSelecionada) {
      return null;
    }
    const [mes, ano] = this.dataSelecionada.split('/');
    return this.s3SrpPublicService.buildImageUrl(`${ano}${mes}`, local.alias);
  }

  get imagemMsUrl(): string | null {
    if (!this.ufSelecionada || !this.dataSelecionada) {
      return null;
    }

    // localizar UF ou País pelo código
    const uf = UFS.find(u => u.sigla === this.ufSelecionada) || this.paises.find(p => p.sigla === this.ufSelecionada);
    if (!uf) {
      return null;
    }

    /**
     * dataSelecionada no formato MM/YYYY
     * Ex: 10/2025 -> 202510
     */
    const [mes, ano] = this.dataSelecionada.split('/');
    if (!mes || !ano) {
      return null;
    }

    const anoMes = `${ano}${mes.padStart(2, '0')}`;

    if (this.ufSelecionada === 'BR') {
      const monthNames = [
        'janeiro', 'fevereiro', 'marco', 'abril', 'maio', 'junho',
        'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
      ];
      const m = Number(mes);
      const y = Number(ano);
      if (Number.isInteger(m) && m >= 1 && m <= 12 && Number.isInteger(y)) {
        const BASE_YEAR = 2025;
        const BASE_MONTH = 10; // outubro
        const BASE_ID = 136; // id para outubro/2025
        const monthsDiff = (y - BASE_YEAR) * 12 + (m - BASE_MONTH);
        const id = BASE_ID + monthsDiff;
        const mêsNome = monthNames[m - 1];
        return `https://ana-monitor-secas-files.s3.sa-east-1.amazonaws.com/uploads/mapas/${id}_${mêsNome}${ano}.png`;
      }
    }

    return `https://ana-monitor-secas-files.s3.sa-east-1.amazonaws.com/uploads/produtos/srm_persist/${anoMes}/ms/ms_${uf.alias}_${anoMes}.png`;
  
  }
  
}
